import React from "react";
import men from "../../../assets/images/osportwears/men.jpg";
import women from "../../../assets/images/osportwears/women.jpg";

const Category = () => {
  return (
    <div className="px-5 md:px-10 lg:px-20 py-20  grid grid-cols-1 md:grid-cols-3 gap-10 justify-center titlefont ">
      <div className=" relative w-full rounded-xl overflow-hidden group">
        <img
          src={men}
          className="w-full -z-10 rounded-xl transition-transform duration-300 group-hover:scale-110 object-cover overflow-hidden"
          alt=""
        />
        <button className="z-10 hidden group-hover:block absolute bottom-7 px-10 py-2 border border-black left-[30%] rounded-md hover:bg-black text-white">
          Men
        </button>
      </div>
      <div className=" relative w-full rounded-xl overflow-hidden group">
        <img
          src={women}
          className="w-full -z-10 rounded-xl transition-transform duration-300 group-hover:scale-110 object-cover overflow-hidden"
          alt=""
        />
        <button className="z-10 hidden group-hover:block absolute bottom-7 px-10 py-2 border border-black left-[25%] rounded-md hover:bg-black text-white">
          Women
        </button>
      </div>
      <div className=" relative w-full rounded-xl overflow-hidden group">
        <img
          src={men}
          className="w-full -z-10 rounded-xl transition-transform duration-300 group-hover:scale-110 object-cover overflow-hidden"
          alt=""
        />
        <button className="z-10 hidden group-hover:block absolute bottom-7 px-10 py-2 border border-black left-[35%] rounded-md hover:bg-black text-white">
          Kids
        </button>
      </div>
    </div>
  );
};

export default Category;
